import {
  DELETE_POI_GROUP_FAILURE,
  DELETE_POI_GROUP_REQUEST,
  DELETE_POI_GROUP_SUCCESS,
  FETCH_POI_GROUP_COMPLETE_FAILURE,
  FETCH_POI_GROUP_COMPLETE_REQUEST,
  FETCH_POI_GROUP_COMPLETE_SUCCESS,
  FETCH_POI_GROUP_FAILURE,
  FETCH_POI_GROUP_REQUEST,
  FETCH_POI_GROUP_SUCCESS,
  FETCH_POI_GROUPS_FAILURE,
  FETCH_POI_GROUPS_REQUEST,
  FETCH_POI_GROUPS_SUCCESS,
  SAVE_POI_GROUP_FAILURE,
  SAVE_POI_GROUP_REQUEST,
  SAVE_POI_GROUP_SUCCESS,
  FETCH_POI_GROUPS_DROPDOWN_REQUEST,
  FETCH_POI_GROUPS_DROPDOWN_SUCCESS,
  FETCH_POI_GROUPS_DROPDOWN_FAILURE,
} from '../../reducers/types';
import {
  deletePoiGroupsService,
  getPoiGroupByIdService,
  getPoiGroupCompleteByIdService,
  getPoiGroupsService,
  savePoiGroupService,
  getPoiGroupsDropdownService,
} from '../../services/appCmsServices/PoiGroupService';
import { poiGroupsPaginationParams } from '../../pages/appCms/poiGroup/Constants';

export const getPoiGroupsAction = (params = null) => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_POI_GROUPS_REQUEST,
      });
      // const response = await dispatch(getPoiGroupsService({ ...poiGroupsPaginationParams }))
      const response = await dispatch(getPoiGroupsService(params));
      if (response.status === 200) {
        dispatch({
          type: FETCH_POI_GROUPS_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_POI_GROUPS_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_POI_GROUPS_FAILURE,
      });
    }
  };
};

export const getPoiGroupsDropdownAction = () => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_POI_GROUPS_DROPDOWN_REQUEST,
      });
      const response = await dispatch(getPoiGroupsDropdownService());
      // const response = await dispatch(getPoiGroupsService(params));
      if (response.status === 200) {
        dispatch({
          type: FETCH_POI_GROUPS_DROPDOWN_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_POI_GROUPS_DROPDOWN_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_POI_GROUPS_DROPDOWN_FAILURE,
      });
    }
  };
};

export const savePoiGroupAction = (data, id = 0) => {
  return async dispatch => {
    try {
      dispatch({
        type: SAVE_POI_GROUP_REQUEST,
      });
      const response = await dispatch(savePoiGroupService(data, id));
      if (response.status === 200) {
        dispatch({
          type: SAVE_POI_GROUP_SUCCESS,
          payload: response.data,
        });
        dispatch(getPoiGroupsAction({ ...poiGroupsPaginationParams }));
      } else {
        dispatch({
          type: SAVE_POI_GROUP_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: SAVE_POI_GROUP_FAILURE,
      });
    }
  };
};

export const deletePoiGroupsAction = array => {
  return async dispatch => {
    try {
      dispatch({
        type: DELETE_POI_GROUP_REQUEST,
      });
      const response = await dispatch(deletePoiGroupsService(array));
      if (response.status === 200) {
        dispatch({
          type: DELETE_POI_GROUP_SUCCESS,
        });
        dispatch(getPoiGroupsAction({ ...poiGroupsPaginationParams }));
      } else {
        dispatch({
          type: DELETE_POI_GROUP_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: DELETE_POI_GROUP_FAILURE,
      });
    }
  };
};

export const getPoiGroupByIdAction = id => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_POI_GROUP_REQUEST,
      });
      const response = await dispatch(getPoiGroupByIdService(id));
      if (response.status === 200) {
        dispatch({
          type: FETCH_POI_GROUP_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_POI_GROUP_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_POI_GROUP_FAILURE,
      });
    }
  };
};

export const getPoiGroupCompleteByIdAction = id => {
  return async dispatch => {
    try {
      dispatch({
        type: FETCH_POI_GROUP_COMPLETE_REQUEST,
      });
      const response = await dispatch(getPoiGroupCompleteByIdService(id));
      if (response.status === 200) {
        dispatch({
          type: FETCH_POI_GROUP_COMPLETE_SUCCESS,
          payload: response.data,
        });
      } else {
        dispatch({
          type: FETCH_POI_GROUP_COMPLETE_FAILURE,
        });
        throw Error;
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch({
        type: FETCH_POI_GROUP_COMPLETE_FAILURE,
      });
    }
  };
};
